import { NationalityModel } from '../../../../../../../services/Settings/NationalityService';
import {
  SortDirection,
  TriOptionsModel,
} from '../../../../../../FrontDeskModule/Shared/components/FrontDeskToolbar';
import { ReservationCardGroupModel } from '../../../../../../ReservationModule/pages/CreateReservationPageNew/models';
import { exportFileTypes } from '../../../../../models/exportFileTypes';

export interface DepartureReportFormModel {
  from: string | null;
  to: string | null;
  rate_ids: Array<number>;
  room_type_ids: Array<number>;
  card_ids: ReservationCardGroupModel[];
  state?: DepartureReportStateEnum;
  balance: boolean;
  nationality_ids: NationalityModel[] | null;
  sortBy: TriOptionsModel;
  sortDirection: SortDirection;
  grouped: boolean;
  exclude_partial: boolean;
  file_type: exportFileTypes;
}

export enum DepartureReportStateEnum {
  DUE_OUT = 'due_out',
  CHECKED_OUT = 'checked_out',
}
